import { render } from "./DialogWindow.vue?vue&type=template&id=2a801f88&ts=true"
import script from "./DialogWindow.vue?vue&type=script&lang=ts"
export * from "./DialogWindow.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\berge\\Desktop\\My Projects\\o2p-shop-planner\\SP.App\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__